import OneAppointmets from './One';

export default function TotalAppointmets({ data, noName, patient }) {
    return (
        <>
            {
                data.map(items => {
                    return (
                        <OneAppointmets
                            key={`appointment_nws_${Date.now()}_${items.id}`}
                            data={items}
                            noName={noName}
                            patient={patient}
                        />
                    )
                })
            }
        </>
    );
}